import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import leftArrow from "../../assets/icons/left-arrow.svg";
import logoCobee from "../../assets/logo-cobee.svg";
import { Logout } from "../../components/Logout";
import Button from "../../components/button";
import { Footer } from "../../components/footer";
import { useMetrics } from "../../metrics";
import { RequestCardContext } from "../../requestCardProvider";
import { ROUTES } from "../../routes";
import classes from "./AddAddress.module.css";
import { CountryIsoCode, useCountryISO2Code } from "./useCountryISO2Code";

const AddAddress = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setAddressFormData } = useContext(RequestCardContext);
  const { pageView, trackAction } = useMetrics();
  const { countryISO2Code } = useCountryISO2Code();

  const handleForm = (event: any) => {
    event.preventDefault();

    const address = event.target.elements["address-line1"];
    const addressNumber = event.target.elements["address-line2"];
    const addressDetail = event.target.elements["address-line3"];
    const postalCode = event.target.elements["postal-code"];
    const city = event.target.elements["address-level2"];
    const province = event.target.elements["address-level1"];

    setAddressFormData({
      address: address.value,
      addressNumber: addressNumber.value,
      addressDetail: addressDetail.value,
      postalCode: postalCode.value,
      city: city.value,
      province: province.value,
      ...(countryISO2Code === CountryIsoCode.MEXICO && {
        district: event.target.elements["district"].value,
      }),
    });

    navigate(ROUTES.ADD_PHONE);
  };

  const handleOnClickSubmit = () => {
    trackAction.click({
      screenName: "AddAddress",
      componentName: "button next",
    });
  };

  const handleOnClickGoBack = () => {
    trackAction.click({
      screenName: "AddAddress",
      componentName: "button go back",
    });
  };

  useEffect(() => {
    pageView("AddAddress");
  }, []);

  return (
    <div className={classes.container}>
      <header className="grid grid-cols-12 mt-4 h-16 items-center w-4/5">
        <Link
          className={`col-span-2 justify-end ${classes.goBack}`}
          to={ROUTES.REQUEST_CARD}
          onClick={handleOnClickGoBack}
        >
          <img src={leftArrow} alt="" />
          {t("common.back")}
        </Link>
        <div className="flex justify-center col-start-3 col-span-8">
          <img
            className={`hidden md:flex  ${classes.logo}`}
            src={logoCobee}
            alt={t("common.logo")}
          />
        </div>
        <div className="col-span-1 items-start w-max">
          <Logout />
        </div>
      </header>
      <div className={classes.infoContainer}>
        <h1 className={classes.title}>{t("request-card.add-address.title")}</h1>
        <p className={classes.description}>
          {t("request-card.add-address.subtitle")}
        </p>
        <form className={classes.formContainer} onSubmit={handleForm}>
          <div className={classes.inputContainer}>
            <input
              id="address-line1"
              name="address-line1"
              autoComplete="address-line1"
              className={classes.input}
              placeholder={t(
                "request-card.add-address.street-name.placeholder"
              )}
              required
            />
            <input
              id="address-line2"
              name="address-line2"
              autoComplete="address-line2"
              className={classes.input}
              type="number"
              placeholder={t(
                "request-card.add-address.street-number.placeholder"
              )}
              required
            />
            <input
              id="address-line3"
              name="address-line3"
              autoComplete="address-line3"
              className={classes.input}
              placeholder={t("request-card.add-address.detail.placeholder")}
            />
            {countryISO2Code === CountryIsoCode.MEXICO && (
              <input
                id="district"
                name="district"
                autoComplete="district"
                className={classes.input}
                placeholder={t("request-card.add-address.district.placeholder")}
                required
              />
            )}
            <div className={classes.twoInputsContainer}>
              <input
                id="postal-code"
                name="postal-code"
                autoComplete="postal-code"
                className={classes.input}
                type="text"
                placeholder={t(
                  "request-card.add-address.postal-code.placeholder"
                )}
                required
              />
              <input
                id="address-level2"
                name="address-level2"
                autoComplete="address-level2"
                className={classes.input}
                placeholder={t("request-card.add-address.locality.placeholder")}
                required
              />
            </div>
            <input
              id="address-level1"
              name="address-level1"
              autoComplete="address-level1"
              className={classes.input}
              placeholder={t("request-card.add-address.province.placeholder")}
              required
            />
          </div>
          <div className={classes.buttonContainer}>
            <Button
              type="submit"
              onClick={handleOnClickSubmit}
              text={t("request-card.add-address.next.button")}
            />
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export { AddAddress };
